export const validateNumber = (num) => {
    const regex = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/;
    return regex.test(num);
  }